
import { Vue } from "vue-property-decorator";
export default class MobileWarning extends Vue {}
